import React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { darken } from 'polished';
import styled from 'styled-components';
import { useMeta } from 'gatsby-theme-core/src/layout/meta';
import LinkedinIn from 'icons/src/LinkedinIn';
import FacebookF from 'icons/src/FacebookF';
import Twitter from 'icons/src/Twitter';
import Column from '../../column/index';

// @TODO make Button
const Link = styled.a`
  background-color: ${(props) => props.theme.primaryColor};
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  margin-left: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => darken(0.2, theme.primaryColor)};
  }

  svg {
    height: 1.5rem;
    color: white;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Share = ({
  columnWidth,
  align,
  justify,
  order,
  offset,
  title,
  facebook = true,
  twitter = true,
  linkedin = true,
}) => {
  const { href: url } = useLocation();
  const { title: pageTitle } = useMeta();

  return (
    <Column
      columnWidth={columnWidth}
      align={align}
      justify={justify}
      order={order}
      offset={offset}
    >
      <Wrapper>
        {title && <span>{title}</span>}
        {facebook && (
          <Link
            href={`http://www.facebook.com/sharer.php?u=${url}&t=${pageTitle}`}
          >
            <FacebookF />
          </Link>
        )}
        {twitter && (
          <Link
            href={`https://twitter.com/intent/tweet?text=${pageTitle}&url=${url}`}
          >
            <Twitter />
          </Link>
        )}
        {linkedin && (
          <Link
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
          >
            <LinkedinIn />
          </Link>
        )}
      </Wrapper>
    </Column>
  );
};

export default styled(Share)``;
